import { generateId } from '@freelancer/datastore/testing';
import { GroupCreatorTypeApi, GroupTypeApi } from 'api-typings/groups/groups';
import { Group, UNREAD_FEED_VALUE } from './groups.model';

export interface GenerateGroupOptions {
  readonly name: string;
  readonly creatorType?: GroupCreatorTypeApi;
  readonly groupType?: GroupTypeApi;
  readonly description?: string;
  readonly created?: number;
  readonly isDeleted?: boolean;
  readonly updated?: number;
  readonly isFeedRead?: boolean;
  readonly lastActiveTime?: number;
}

function generateGroupObject({
  name,
  creatorType = GroupCreatorTypeApi.ADMIN,
  groupType = GroupTypeApi.TALENT_POOL,
  description,
  created = Date.now(),
  updated = Date.now(),
  isDeleted = false,
  isFeedRead = false,
  lastActiveTime = Date.now(),
}: GenerateGroupOptions): Group {
  const id = generateId();
  return {
    id,
    name,
    creatorId: generateId(),
    creatorType,
    seoUrl: `group-${id}`,
    groupType,
    description,
    created,
    isDeleted,
    isFeedRead,
    lastActiveTimeInMs: lastActiveTime,
    orderByFeedReadLatestTimeInMs:
      (!isFeedRead ? UNREAD_FEED_VALUE : 0) + lastActiveTime,
    updated,
  };
}

export function generateGroupsObject(
  groups: readonly GenerateGroupOptions[],
): readonly Group[] {
  return groups.map(generateGroupObject);
}
